let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dlfYX")).then(() => parcelRequire('a6lR8'));